import Vue from 'vue';
import VueI18n from "vue-i18n";
import localStorage from 'store';
import moment from 'moment';

import zh from './zh';

Vue.use(VueI18n);

// 支撑的语言列表
export const localeList = [
  {'lang':'zh', 'text': '中文'},
  {'lang':'en', 'text': 'English'},
];

// 默认语言
export const defaultLang = 'zh';

const messages = {
  'zh': {
    ...zh
  }
};

const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: zh,
  fallbackLocale: defaultLang,
  messages
});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

// 已经加载过的语言
const loadedLanguages = [defaultLang];

// 异步加载语言文件
export function loadLanguageAsync(lang = defaultLang) {
  return new Promise(resolve => {
    localStorage.set('lang', lang);
    if(i18n.locale !== lang) {
      if(!loadedLanguages.includes(lang)) {
        return import(`./${lang}/`).then(msg => {
          const locale = msg.default;
          i18n.setLocaleMessage(lang, locale);
          loadedLanguages.push(lang);
          moment.updateLocale(locale.monentName, locale.momentLocale);
          return setI18nLanguage(lang);
        });
      }
      return resolve(setI18nLanguage(lang));
    }
    return resolve(lang);
  });
}

export function i18nRender(key) {
  return i18n.t(`${key}`);
}

export default i18n;